import {
  GET_GLOBAL_VERTICAL_METRICES,
  GET_GLOBAL_VERTICAL_METRICES_SUCCESS,
  GET_GLOBAL_VERTICAL_METRICES_ERROR,
  GET_GLOBAL_VERTICAL_METRICES_EMPTY,
} from '../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetGlobalVerticalMetrices = (state = initialState, action) => {
  switch (action.type) {
    case GET_GLOBAL_VERTICAL_METRICES:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_GLOBAL_VERTICAL_METRICES_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_GLOBAL_VERTICAL_METRICES_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_GLOBAL_VERTICAL_METRICES_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetGlobalVerticalMetrices;
